import React, { Component } from "react";
import { QUESTION_IDS, ANSWER_IDS, STRINGS, UI } from "../constants";
import { track } from "@amplitude/analytics-browser";
import { AMPLITUDE_EVENTS } from "../config/amplitude";
class CustomerSatisfaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      satisfied: "",
      services: "",
      communicating: "",
      hear: "",
      hearinfo: "",
      recommend: "",
      errors: {},
    };
  }

  componentDidMount() {
    // Track survey step view
    track(AMPLITUDE_EVENTS.SURVEY_VIEW_STEP, {
      page_type: "CustomerSatisfaction",
      step: this.props.values.step,
      requestId: this.props.values.requestId,
      medium: this.props.values.medium,
    });
  }

  handleForm = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleTouch = event => {
    // Prevent default touch behavior and ensure radio selection works on iOS
    event.preventDefault();
    const radio = event.currentTarget.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
      this.setState({ [radio.name]: radio.value });
    }
  };

  handlesubmit = event => {
    if (this.validateForm()) {
      const obj7 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: this.state.satisfied,
        questionId: QUESTION_IDS.SATISFACTION_WITH_SERVICE,
        responseInfo: STRINGS.NA,
        createDt: this.props.values.date,
      };

      if (this.state.services === "") {
        var services = STRINGS.NA;
      } else {
        var services = this.state.services;
      }

      const obj8 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: ANSWER_IDS.SERVICE_IMPROVEMENT,
        questionId: QUESTION_IDS.IMPROVE_MATCHING_SERVICES,
        responseInfo: services,
        createDt: this.props.values.date,
      };

      if (this.state.communicating === "") {
        var communicating = STRINGS.NA;
      } else {
        var communicating = this.state.communicating;
      }

      const obj9 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: ANSWER_IDS.COMMUNICATION_METHODS,
        questionId: QUESTION_IDS.ADDITIONAL_COMMUNICATION_METHODS,
        responseInfo: communicating,
        createDt: this.props.values.date,
      };

      if (this.state.hear === ANSWER_IDS.HEAR_OTHER) {
        var hearOther = this.state.hearinfo;
      } else {
        var hearOther = STRINGS.NA;
      }
      const obj10 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: this.state.hear,
        questionId: QUESTION_IDS.HOW_HEARD_ABOUT_US,
        responseInfo: hearOther,
        createDt: this.props.values.date,
      };

      const obj11 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: this.state.recommend,
        questionId: QUESTION_IDS.LIKELIHOOD_TO_RECOMMEND,
        responseInfo: STRINGS.NA,
        createDt: this.props.values.date,
      };

      this.props.handleSubmit5(obj7, obj8, obj9, obj10, obj11);
    }
  };

  validateForm() {
    let fields = this.state;
    let errors = {};
    let formIsValid = true;
    if (fields.satisfied === "") {
      formIsValid = false;
      errors["satisfiederror"] = "Kindly select an option below to proceed";
    }

    // if(fields.communicating === ""){
    //     formIsValid = false;
    //     errors["communicatingerror"] = "Kindly select an option below to proceed";
    // }
    if (fields.hear === "") {
      formIsValid = false;
      errors["hearerror"] = "Kindly select an option below to proceed";
    }
    if (fields.hear === ANSWER_IDS.HEAR_OTHER && fields.hearinfo === "") {
      formIsValid = false;
      errors["hearinfoerror"] = "This is a required field";
    }
    if (fields.recommend === "") {
      formIsValid = false;
      errors["recommenderror"] = "Kindly select an option below to proceed";
    }

    this.setState({
      errors: errors,
    });

    // Track validation errors if form is invalid
    if (!formIsValid) {
      track(AMPLITUDE_EVENTS.SURVEY_ANSWER_SUBMISSION_ERROR, {
        component: "CustomerSatisfaction",
        error: "Form validation failed",
        requestId: this.props.values.requestId,
        medium: this.props.values.medium,
        step: "customer_satisfaction_form_validation",
        validationErrors: errors,
        errorMessages: Object.values(errors),
        errorCount: Object.keys(errors).length,
      });
    }

    return formIsValid;
  }

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    return (
      <>
        <section className="feedback-service">
          <div className="container" style={{ textAlign: "left" }}>
            <div className="row">
              <div className="col-md-12">
                <h2>
                  How satisfied were you with WiserAdvisor's matching service?
                  <div id="rsp_email" className="error">
                    {this.state.errors.satisfiederror}
                  </div>
                </h2>
                <div className="ranking-scale">
                  <label className="radio-inline">Not satisfied</label>
                  <label className="radio-inline">Satisfied</label>
                  <label className="radio-inline">Very satisfied</label>
                </div>
                <div className="scale-rating">
                  <label
                    value="1"
                    className={
                      this.state.satisfied === ANSWER_IDS.SATISFACTION_1
                        ? "radioactive"
                        : "nonactive"
                    }
                    onTouchStart={this.handleTouch}
                  >
                    <input
                      type="radio"
                      value={ANSWER_IDS.SATISFACTION_1}
                      name="satisfied"
                      onChange={this.handleForm}
                    />
                    <span>1</span>
                  </label>
                  <label
                    value="2"
                    className={
                      this.state.satisfied === ANSWER_IDS.SATISFACTION_2
                        ? "radioactive"
                        : "nonactive"
                    }
                    onTouchStart={this.handleTouch}
                  >
                    <input
                      type="radio"
                      value={ANSWER_IDS.SATISFACTION_2}
                      name="satisfied"
                      onChange={this.handleForm}
                    />
                    <span>2</span>
                  </label>
                  <label
                    value="3"
                    className={
                      this.state.satisfied === ANSWER_IDS.SATISFACTION_3
                        ? "radioactive"
                        : "nonactive"
                    }
                    onTouchStart={this.handleTouch}
                  >
                    <input
                      type="radio"
                      value={ANSWER_IDS.SATISFACTION_3}
                      name="satisfied"
                      onChange={this.handleForm}
                    />
                    <span>3</span>
                  </label>
                  <label
                    value="4"
                    className={
                      this.state.satisfied === ANSWER_IDS.SATISFACTION_4
                        ? "radioactive"
                        : "nonactive"
                    }
                    onTouchStart={this.handleTouch}
                  >
                    <input
                      type="radio"
                      value={ANSWER_IDS.SATISFACTION_4}
                      name="satisfied"
                      onChange={this.handleForm}
                    />
                    <span>4</span>
                  </label>
                  <label
                    value="5"
                    className={
                      this.state.satisfied === ANSWER_IDS.SATISFACTION_5
                        ? "radioactive"
                        : "nonactive"
                    }
                    onTouchStart={this.handleTouch}
                  >
                    <input
                      type="radio"
                      value={ANSWER_IDS.SATISFACTION_5}
                      name="satisfied"
                      onChange={this.handleForm}
                    />
                    <span>5</span>
                  </label>
                </div>
              </div>
              <div className="col-md-12">
                <h2>
                  How would you improve our matching services?
                  <div id="rsp_email" className="error">
                    {this.state.errors.serviceserror}
                  </div>{" "}
                </h2>
                <textarea
                  class="additional textarea"
                  name="services"
                  rows={UI.TEXTAREA_ROWS}
                  cols={UI.TEXTAREA_COLS}
                  onChange={this.handleForm}
                />
              </div>
              <div className="col-md-12">
                <h2>
                  Are there any additional methods of communication you would
                  have liked to use with your advisor matches?
                  <div id="rsp_email" className="error">
                    {this.state.errors.communicatingerror}
                  </div>{" "}
                </h2>
                <input
                  type="text"
                  className="additional"
                  name="communicating"
                  onChange={this.handleForm}
                ></input>
              </div>
              <div className="col-md-12">
                <h2>
                  How did you hear about us?
                  <div id="rsp_email" className="error">
                    {this.state.errors.hearerror}
                  </div>
                </h2>

                <label className="radio-inline">
                  <input
                    type="radio"
                    name="hear"
                    value={ANSWER_IDS.HEAR_INTERNET}
                    onChange={this.handleForm}
                  />
                  Internet Search
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="hear"
                    value={ANSWER_IDS.HEAR_AD}
                    onChange={this.handleForm}
                  />
                  Online Ad
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="hear"
                    value={ANSWER_IDS.HEAR_PODCAST}
                    onChange={this.handleForm}
                  />
                  Podcast
                </label>

                <label className="radio-inline">
                  <input
                    type="radio"
                    name="hear"
                    value={ANSWER_IDS.HEAR_FRIEND}
                    onChange={this.handleForm}
                  />
                  Friend or Family Member
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="hear"
                    value={ANSWER_IDS.HEAR_OTHER}
                    onChange={this.handleForm}
                  />
                  Other
                </label>
                <input
                  type="text"
                  className="additional"
                  name="hearinfo"
                  disabled={
                    this.state.hear !== ANSWER_IDS.HEAR_OTHER
                      ? "disabled"
                      : null
                  }
                  placeholder="IF OTHER PLEASE SPECIFY"
                  onChange={this.handleForm}
                ></input>
                <div id="rsp_email" className="error">
                  {this.state.errors.hearinfoerror}
                </div>
              </div>

              <div className="col-md-12">
                <h2>
                  How likely are you to recommend WiserAdvisor's financial
                  matching services to others?
                  <div id="rsp_email" className="error">
                    {this.state.errors.recommenderror}
                  </div>
                </h2>
                <div className="ranking-scale">
                  <label className="radio-inline">Not Likely</label>
                  <label className="radio-inline">Maybe</label>
                  <label className="radio-inline">Definitely</label>
                </div>
                <div className="scale-rating">
                  <label
                    value="1"
                    className={
                      this.state.recommend === ANSWER_IDS.RECOMMEND_1
                        ? "radioactive"
                        : "nonactive"
                    }
                    onTouchStart={this.handleTouch}
                  >
                    <input
                      type="radio"
                      value={ANSWER_IDS.RECOMMEND_1}
                      name="recommend"
                      onChange={this.handleForm}
                    />
                    <span>1</span>
                  </label>
                  <label
                    value="2"
                    className={
                      this.state.recommend === ANSWER_IDS.RECOMMEND_2
                        ? "radioactive"
                        : "nonactive"
                    }
                    onTouchStart={this.handleTouch}
                  >
                    <input
                      type="radio"
                      value={ANSWER_IDS.RECOMMEND_2}
                      name="recommend"
                      onChange={this.handleForm}
                    />
                    <span>2</span>
                  </label>
                  <label
                    value="3"
                    className={
                      this.state.recommend === ANSWER_IDS.RECOMMEND_3
                        ? "radioactive"
                        : "nonactive"
                    }
                    onTouchStart={this.handleTouch}
                  >
                    <input
                      type="radio"
                      value={ANSWER_IDS.RECOMMEND_3}
                      name="recommend"
                      onChange={this.handleForm}
                    />
                    <span>3</span>
                  </label>
                  <label
                    value="4"
                    className={
                      this.state.recommend === ANSWER_IDS.RECOMMEND_4
                        ? "radioactive"
                        : "nonactive"
                    }
                    onTouchStart={this.handleTouch}
                  >
                    <input
                      type="radio"
                      value={ANSWER_IDS.RECOMMEND_4}
                      name="recommend"
                      onChange={this.handleForm}
                    />
                    <span>4</span>
                  </label>
                  <label
                    value="5"
                    className={
                      this.state.recommend === ANSWER_IDS.RECOMMEND_5
                        ? "radioactive"
                        : "nonactive"
                    }
                    onTouchStart={this.handleTouch}
                  >
                    <input
                      type="radio"
                      value={ANSWER_IDS.RECOMMEND_5}
                      name="recommend"
                      onChange={this.handleForm}
                    />
                    <span>5</span>
                  </label>
                </div>
              </div>

              <div className="col-md-3"></div>
              <div className="col-md-6">
                <input
                  type="button"
                  name="previous"
                  className="next btn-update action-button nextOne"
                  style={{ cursor: "pointer" }}
                  value="PREVIOUS"
                  onClick={this.back}
                />
                <input
                  type="button"
                  name="next"
                  className="next btn-update action-button nextOne"
                  style={{
                    cursor: "pointer",
                    marginLeft: UI.MARGIN_LEFT,
                  }}
                  value="SUBMIT"
                  onClick={this.handlesubmit}
                />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default CustomerSatisfaction;
